module.exports = __webpack_public_path__ + "img/ES3018.a984a94a.png";